import React from 'react'
import Placeholder from '../placeholder/Placeholder'

const CycleOrderPlaceholder:React.FC = () => {
  return (
    <Placeholder />
  )
}

export default CycleOrderPlaceholder
